import { apiDeleteBooking } from "../../api/apiDeleteBooking";
import { editBookingReset } from "./editBooking";

export const DELETE_BOOKING_START_REQUEST = 'DELETE_BOOKING_START_REQUEST';
export const deleteBookingStartRequest = () => ({ type: DELETE_BOOKING_START_REQUEST });

export const DELETE_BOOKING_ERROR_REQUEST = 'DELETE_BOOKING_ERROR_REQUEST';
export const deleteBookingErrorRequest = () => ({ type: DELETE_BOOKING_ERROR_REQUEST });

export const DELETE_BOOKING_SUCCESS_REQUEST = 'DELETE_BOOKING_SUCCESS_REQUEST';
export const deleteBookingSuccessRequest = () => ({ type: DELETE_BOOKING_SUCCESS_REQUEST });

export const deleteBookingAction = ({ storeId, bookingCode }) => async dispatch => {
    if (!storeId || !bookingCode) {
        return dispatch(deleteBookingErrorRequest());
    }
    dispatch(deleteBookingStartRequest());
    try {
        await apiDeleteBooking({ storeId, bookingCode });
    } catch (error) {
        console.log(error);
        return dispatch(deleteBookingErrorRequest());
    }
    dispatch(editBookingReset());
    dispatch(deleteBookingSuccessRequest());
}


// WEBPACK FOOTER //
// ./src/store/actions/deleteBooking.js